import * as React from "react";
import { createFromIconfontCN } from "@ant-design/icons";

const MyIcon = createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/font_1452373_caf4r0kv5e8.js", // 在 iconfont.cn 上生成
});

export default MyIcon;

// 如何使用
/* <MyIcon type="icon-m-lighting" /> */
